import { render } from "./TextSticker.vue?vue&type=template&id=71f3cbac&scoped=true"
import script from "./TextSticker.vue?vue&type=script&lang=js"
export * from "./TextSticker.vue?vue&type=script&lang=js"

import "./TextSticker.vue?vue&type=style&index=0&id=71f3cbac&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f3cbac"]])

export default __exports__